import moment from 'moment-wrapper';


function getLastPeriodForRange (dateRange) {
  const dateStart = moment(dateRange.dateStart);
  const dateEnd = moment(dateRange.dateEnd);

  const rangeKey = dateRange.rangeKey;
  const days = dateEnd.diff(dateStart, 'days') + 1;

  const lastPeriod = {dateStart: null, dateEnd: null};

  switch (rangeKey) {
  case 'Yesterday':
    lastPeriod.dateStart = dateStart.subtract(1, 'day');
    lastPeriod.dateEnd = lastPeriod.dateStart;
    break;
  case 'Last 7 days':
    lastPeriod.dateStart = dateStart.subtract(8, 'day');
    lastPeriod.dateEnd = dateStart.add(7, 'day');
    break;
  case 'This week':
    lastPeriod.dateStart = dateStart.subtract(7, 'day');
    lastPeriod.dateEnd = dateEnd.subtract(7, 'day');
    break;
  case 'Last week':
    lastPeriod.dateStart = dateStart.subtract(1, 'week').startOf('week');
    lastPeriod.dateEnd = dateEnd.subtract(1, 'week').endOf('week');
    break;
  case 'This month':
    lastPeriod.dateStart = dateStart.subtract(1, 'month').startOf('month');

    if (moment(lastPeriod.dateStart).subtract(1, 'month').
      daysInMonth() < days) {
      lastPeriod.dateEnd = dateEnd.subtract(1, 'month').endOf('month');
    } else {
      lastPeriod.dateEnd = dateStart.add(days - 1, 'day');
    }
    break;
  case 'Last month':
    lastPeriod.dateStart = dateStart.subtract(1, 'month').startOf('month');
    lastPeriod.dateEnd = dateEnd.subtract(1, 'month').endOf('month');
    break;
  default:
    lastPeriod.dateEnd = dateStart.clone().subtract(1, 'day');
    lastPeriod.dateStart = dateStart.clone().subtract(days, 'day');
    break;
  }

  return {
    dateStart: lastPeriod.dateStart.formatDateApi(),
    dateEnd: lastPeriod.dateEnd.formatDateApi()
  };
}

export default getLastPeriodForRange;
